import api from '../client'

export async function fetchEmployeeGroupOptions(params = {}) {
  const { search = '', page = 1, pageSize = 50 } = params
  const res = await api.get('/options/employee-groups', {
    params: {
      search,
      page,
      page_size: pageSize,
    },
  })
  return res.data
}
